export default "__VITE_ASSET__024b74b6__"